import React from 'react';
import { map, differenceBy, sortBy } from 'lodash/fp';
import { makeStyles, fade, lighten } from '@material-ui/core/styles';
import {
  Button,
  Typography,
  IconButton,
  ListItemSecondaryAction,
  ListItemText,
  ListItem,
  List,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';

const useStyles = makeStyles(theme => ({
  listContainer: {
    margin: theme.spacing(3, 0),
    width: '100%',
  },
  emptyListMessage: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(2, 1),
    textAlign: 'center',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.grey[300],
  },
  listItemBorder: {
    border: `1px solid ${lighten(fade(theme.palette.divider, 1), 0.88)}`,
    marginBottom: -1,
  },
  listItemButton: {
    color: theme.palette.grey[400],
  },
  listButton: {
    marginTop: theme.spacing(1),
  },
}));

export default ({ selectedAgencies = [], agencies = [], addAgency, removeAgency }) => {
  const classes = useStyles();
  const availableAgencies = differenceBy('id', agencies, selectedAgencies);
  return (
    <div className={classes.listContainer}>
      <Typography variant="h6">Agencies</Typography>
      {Boolean(selectedAgencies.length) && (
        <List>
          {map(
            ({ id, name }) => (
              <ListItem key={id} className={classes.listItemBorder}>
                <ListItemText primary={name.toUpperCase()} />
                {removeAgency && (
                  <ListItemSecondaryAction onClick={() => removeAgency(id)}>
                    <IconButton edge="end" aria-label="delete" className={classes.listItemButton}>
                      <DeleteIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                )}
              </ListItem>
            ),
            sortBy('name', selectedAgencies)
          )}
        </List>
      )}

      {!selectedAgencies.length && (
        <div className={classes.emptyListMessage}>No agency selected</div>
      )}

      {Boolean(availableAgencies.length && addAgency) && (
        <Button
          variant="contained"
          className={classes.listButton}
          startIcon={<AddIcon />}
          onClick={addAgency}
          disabled
        >
          Add Agency
        </Button>
      )}

      {Boolean(!availableAgencies.length && addAgency) && (
        <Button variant="contained" className={classes.listButton} startIcon={<AddIcon />} disabled>
          Add Team
        </Button>
      )}
    </div>
  );
};
